module.exports = {"images":[{"public_id":"anderspp/IMG_0052_wwniy9","version":1591541798,"format":"jpg","width":955,"height":1195,"type":"upload","created_at":"2020-06-07T14:56:38Z","context":{"custom":{"alt":"https://warhammerfantasy.fandom.com/wiki/Glottkin","caption":"The Glottkin"}}}],"updated_at":"2020-06-07T15:02:20Z"}


//////////////////
// WEBPACK FOOTER
// ./src/pages/image_list_tt_gone.json
// module id = 76
// module chunks = 0